<template>
	<div class="header-wrap">
		<div class="header">
			<div class="header-l">
				<a href="/" title="圆满假期"><img alt="圆满假期" class="logo" src="@/assets/logo.png"/></a>
			</div>
			<div class="header-l">
				<ul class="school-wrap">
					<li>
						院校：<span class="count">{{schoolCount}}</span>
					</li>
					<li>
						大学生：<span class="count">{{studentCount}}</span>
					</li>
				</ul>
			</div>
			<div class="header-r">
				<ul class="menu-wrap">
					<li>
						<router-link to="/home" exact>平台业务</router-link>
					</li>
					<li>
						<router-link to="/activity">已有活动</router-link>
					</li>
					<li>
						<router-link to="/dynamic">所有动态</router-link>
					</li>
					<li>
						<router-link to="/activitySubmit">发起活动</router-link>
					</li>
					<li>
						<router-link to="/aboutus">关于我们</router-link>
					</li>
					<!-- <li>
						<router-link to="/settle">入驻</router-link>
					</li> -->
					<li class="login-btn">
						<router-link to="/login">登录/注册</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Header',
		props: {
			
		},
		data(){
			return {
				schoolCount: 0,
				studentCount: 0
			}
		},
		created(){
			this.getConfigData()
		},
		methods: {
			//获取底部数据
			async getConfigData(){
				let param = {
					keyCode: 'SMALL-PRO'
				}
				ajaxParam(param)
				const res = await post('v1/sysConfig/getSysConfigListByKeyCode', qs.stringify(param))
				if(res.data.code==200){
					console.log('------')
					console.log(res.data)
					let dataList = res.data.list
					dataList.forEach(item=>{
						if (item.configKey == 'SCHOOL-COUNT') {
							this.schoolCount = item.configValue
						}
						if (item.configKey == 'STUDENT-COUNT') {
							this.studentCount = item.configValue
						}
					})
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.header-wrap{
		background: #fff;
		padding: 10px 0;
		box-shadow: 0 1px 8px 0 rgba(34, 123, 255, .24);
		position: relative;
		z-index: 2;
		// position: fixed;
		// left: 0;
		// right: 0;
		// top: 0;
		// z-index: 99;
	}
	.header{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 1180px;
		margin: 0 auto;
		box-sizing: border-box;
		.header-l{
			display: flex;
			align-items: center;
		}
		.logo{
			width: 132px;
			height: 66px;
			margin-right: 15px;
		}
		.school-wrap{
		    display: flex;
		    align-items: center;
		    margin-left: -220px
		}
		
		.school-wrap li{
		    margin: 0 20px;
		    padding: 6px 6px;
		    text-align: center;
		    line-height: 1;
		    border-bottom: 4px solid transparent;
		    white-space: nowrap;
		    cursor: pointer;
		    font-weight: 700
		}
		
		.school-wrap li .count{
		    color: #f55
		}
		.menu-wrap {
			display: flex;
			align-items: center;
			li{
				margin: 0 14px;
				padding: 6px 6px;
				text-align: center;
				line-height: 1;
				border-bottom: 4px solid transparent;
				white-space: nowrap;
				cursor: pointer;
				font-weight: bold;
				a.router-link-active{
					color: #f55;
				}
			}
			li.login-btn{
				display: block;
				background: #f55;
				padding: 0 10px 2px;
				line-height: 28px;
				border-radius: 5px;
				border-bottom: none;
				color:#fff;
				a{
					color:#fff;
				}
			}
		}
	}
</style>
